import * as React from "react";
import { forwardRef } from "react";
const SvgIconUnchecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3, width: 18, height: 18, rx: 1, stroke: "#8C9EBA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("rect", { x: 1.5, y: 1.5, width: 21, height: 21, rx: 2.5, stroke: "#182231" }));
const ForwardRef = forwardRef(SvgIconUnchecked);
export { ForwardRef as ReactComponent };
